export default __webpack_public_path__ + "static/bannerBackground-516b742b5776fd3606e543e6e0ecea9d.svg";